var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('XCircleIcon',{staticClass:"mx-auto h-12 w-12 text-red-400"}),_c('div',{staticClass:"text-center text-red-400 font-bold text-sm tracking-wide uppercase"},[_vm._v("Error")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }